import React, { Fragment } from 'react';
import { generatePath } from 'react-router';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import Heading from '../../../common/heading/Heading';
import BackToLogin from '../../../common/links/BackToLogin';
import { ROUTE_FORGOT_PASSWORD } from '../../../../../common/constants/Routes';
import {
	ONBOARDING_RESET_LINK_EXPIRED_TITLE,
	ONBOARDING_RESET_LINK_EXPIRED_SUBTITLE,
	ONBOARDING_RESET_LINK_EXPIRED_CTA,
} from '../../../../constants/Copy';

const ResetLinkInvalid = () => (
	<Fragment>
		<Heading>{ONBOARDING_RESET_LINK_EXPIRED_TITLE}</Heading>
		<p className="onboarding__text">{ONBOARDING_RESET_LINK_EXPIRED_SUBTITLE}</p>
		<p className="onboarding__text">
			<Button href={generatePath(ROUTE_FORGOT_PASSWORD)}>
				{ONBOARDING_RESET_LINK_EXPIRED_CTA}
			</Button>
		</p>
		<BackToLogin />
	</Fragment>
);

export default ResetLinkInvalid;
